/**
 * Package validation — mirrors `PackageSchema` in
 * apps/service-mail/src/modules/draft/draft.dto.ts.
 *
 * Money values are decimal strings (per ADR-001 §5 + upmp/no-number-money).
 */
import { z } from 'zod';

const DECIMAL_4DP = /^\d+(\.\d{1,4})?$/;
const DECIMAL_2DP = /^\d+(\.\d{1,2})?$/;

export const PackageSchema = z.object({
  weightKg: z
    .string()
    .min(1, 'Weight is required')
    .regex(DECIMAL_4DP, 'Weight must be a decimal (up to 4 fractional digits)'),
  dimensionsCm: z
    .object({
      length: z.string().regex(DECIMAL_2DP, 'Length must be a decimal (up to 2dp)'),
      width: z.string().regex(DECIMAL_2DP, 'Width must be a decimal (up to 2dp)'),
      height: z.string().regex(DECIMAL_2DP, 'Height must be a decimal (up to 2dp)'),
    })
    .optional(),
  declaredValueNgn: z
    .string()
    .regex(DECIMAL_4DP, 'Declared value must be a decimal')
    .optional()
    .or(z.literal('').transform(() => undefined)),
  contentDescription: z
    .string()
    .min(1, 'Content description is required')
    .max(500, 'Description cannot exceed 500 characters'),
  declaredItems: z.array(z.string().min(1).max(200)).max(50).optional(),
  notes: z.string().max(1000).optional(),
});

export type PackageValidated = z.infer<typeof PackageSchema>;
